module.exports = __webpack_public_path__ + "static/media/smile.6e5b706a.jpg";